import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  success: false,
  error: null,
  clientSecret: null,
  tipId: null,
  retryCount: 0, // Licznik prób
  isRetrying: false, // Czy trwa ponowna próba
};

const TipSlice = createSlice({
  name: "Tip",
  initialState,
  reducers: {
    // Tworzenie płatności napiwku
    createTipPaymentRequest(state) {
      state.loading = true;
      state.success = false;
      state.error = null;
      state.clientSecret = null;
      state.retryCount = 0;
      state.isRetrying = false;
    },
    createTipPaymentSuccess(state, action) {
      state.loading = false;
      state.success = false;
      state.clientSecret = action.payload.clientSecret;
      state.tipId = action.payload.tipId;
      state.error = null;
      state.retryCount = 0;
      state.isRetrying = false;
    },
    createTipPaymentFailed(state, action) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
      state.clientSecret = null;
      state.retryCount = 0;
      state.isRetrying = false;
    },

    // Potwierdzenie płatności BLIK
    confirmBlikPaymentRequest(state) {
      state.loading = true;
      state.error = null;
      // Jeśli to nie pierwsza próba, oznacz jako retry
      if (state.retryCount > 0) {
        state.isRetrying = true;
      }
    },
    confirmBlikPaymentSuccess(state) {
      state.loading = false;
      state.success = true;
      state.error = null;
      state.retryCount = 0;
      state.isRetrying = false;
    },
    confirmBlikPaymentFailed(state, action) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
      state.retryCount = 0;
      state.isRetrying = false;
    },

    // Inkrementacja licznika prób (wywołana w thunk przed każdą próbą)
    incrementRetryCount(state) {
      state.retryCount += 1;
      state.isRetrying = true;
    },

    // Reset stanu
    resetTipState(state) {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.clientSecret = null;
      state.tipId = null;
      state.retryCount = 0;
      state.isRetrying = false;
    },
  },
});

export const {
  createTipPaymentRequest,
  createTipPaymentSuccess,
  createTipPaymentFailed,
  confirmBlikPaymentRequest,
  confirmBlikPaymentSuccess,
  confirmBlikPaymentFailed,
  incrementRetryCount,
  resetTipState,
} = TipSlice.actions;

export default TipSlice.reducer;
